<div class="flex flex-col justify-between gap-4">
    <mat-dialog-content class="flex-grow p-4">
        <h2 mat-dialog-title>{{ title | translate }}</h2>
        <p>{{ text | translate }}</p>
        <form [formGroup]="form" class="flex flex-col gap-2">
            <section>
                <mat-form-field class="w-full">
                    <mat-label>{{ label | translate}}</mat-label>
                    <mat-select formControlName="data" [multiple]="multiple" [required]="true">
                        <mat-option *ngFor="let item of data; let i = index" [value]="item"> {{ item | translateIso | translate }} </mat-option>
                    </mat-select>
                </mat-form-field>
            </section>
            <section *ngIf="order && form.get('data')?.value?.length > 1" class="">
                <mat-label>{{ 'REORDER' | translate }}</mat-label>
                <div cdkDropList class="order-list scroll-hide" cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)">
                    <div class="order-box" *ngFor="let item of form.get('data')?.value" cdkDrag>
                        {{ item | translateIso | translate }}
                    </div>
                </div>
            </section>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions class="w-full flex justify-between">
        <button mat-flat-button [mat-dialog-close]="true" class="flex-grow bg-tw-disabled">{{ 'CANCEL' | translate }}</button>
        <button mat-flat-button [mat-dialog-close]="true" class="flex-grow bg-tw-primary text-tw-text-light" [disabled]="!isValid" (click)="submit()"> {{ valid | translate }} </button>
    </mat-dialog-actions>
</div>